import { jsx as _jsx } from "react/jsx-runtime";
import { createElement, forwardRef, lazy, Suspense, useRef, } from 'react';
import { useRegisterComponent } from './PreloadContext.js';
let preloads = [];
export function loadable(factory, options, moduleId = '') {
    const getResolvedOrDefaultExport = (module) => options?.resolveComponent
        ? options.resolveComponent(module)
        : module.default;
    const lazyFactory = async () => {
        const module = await factory();
        return { default: getResolvedOrDefaultExport(module) };
    };
    const ReactLazyComponent = lazy(lazyFactory);
    let PreloadedComponent;
    let factoryPromise;
    const Component = forwardRef(function LazyWithPreload(props, ref) {
        // Once one of these is chosen, we must ensure that it continues to be
        // used for all subsequent renders, otherwise it can cause the
        // underlying component to be unmounted and remounted.
        const ComponentToRender = useRef(PreloadedComponent ?? ReactLazyComponent);
        useRegisterComponent(moduleId, Boolean(options?.ssr));
        if (options?.fallback) {
            return (_jsx(Suspense, { fallback: options?.fallback, children: createElement(ComponentToRender.current, Object.assign(ref ? { ref } : {}, props)) }));
        }
        return createElement(ComponentToRender.current, Object.assign(ref ? { ref } : {}, props));
    });
    const LazyWithPreload = Component;
    LazyWithPreload.preload = () => {
        if (!factoryPromise) {
            factoryPromise = factory().then((module) => {
                PreloadedComponent = getResolvedOrDefaultExport(module);
                return PreloadedComponent;
            });
        }
        return factoryPromise;
    };
    preloads.push(LazyWithPreload.preload);
    return LazyWithPreload;
}
export async function preloadAll(depth = 3) {
    for (let i = 0; i < depth && preloads.length > 0; i++) {
        const _preloads = preloads;
        preloads = [];
        if (_preloads.length === 0) {
            return;
        }
        await Promise.all(_preloads.map((preload) => preload()));
    }
}
